import { Callback } from '@picsart/cloud-storage/types/models';

class LoaderService {
  private isOpen = false;

  private subscribers: Callback[] = [];

  open() {
    this.isOpen = true;
    this.updateSubscribers();
  }

  close() {
    this.isOpen = false;
    this.updateSubscribers();
  }

  subscribe(cb: Callback) {
    this.subscribers.push(cb);
  }

  updateSubscribers() {
    this.subscribers.forEach(subscriber => subscriber(this.isOpen));
  }
}

export default new LoaderService();
